export enum BulkUploadPhase {
    Parsing = 'Parsing',
    Validating = 'Validating',
    Persisting = 'Persisting',
    Done = 'Done',
}
